<script setup lang="ts">
import { ref } from "vue";

// Lightweight hover/focus tooltip. The trigger is the default slot; the
// floating content is the `content` slot, so it can host rich markup
// (e.g. a <Duration>) rather than a plain title="" string.
const open = ref(false);
</script>

<template>
  <span
    class="relative inline-flex"
    @pointerenter="open = true"
    @pointerleave="open = false"
    @focusin="open = true"
    @focusout="open = false"
  >
    <slot />
    <span
      v-if="open"
      role="tooltip"
      class="pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-zinc-800 px-2 py-1 text-xs text-zinc-100 shadow-lg ring-1 ring-zinc-700"
    >
      <slot name="content" />
    </span>
  </span>
</template>
